import * as React from 'react';
import * as _ from 'underscore';

import { HeaderStyles } from './HeaderStyles';

export class HeaderIconButton extends React.Component<HeaderIconButton.Props, HeaderIconButton.State> {

  static displayName = 'HeaderIconButton';
  static searchBoxIconButtonId = 'search-box-icon-button';

  static element = React.createFactory(HeaderIconButton);

  state: HeaderIconButton.State = {
    hovered: false
  };

  private boundClick = () => this.handleClick();
  private boundMouseEnter = () => this.setState({ hovered: true });
  private boundMouseLeave = () => this.setState({ hovered: false });

  private ignoreEvent(e: React.SyntheticEvent<HTMLElement>) {
    e.preventDefault();
  }

  private handleClick() {
    this.props.handleClick();
  }

  public render() {
    return React.createElement('div', {
      onMouseEnter: this.boundMouseEnter,
      onMouseLeave: this.boundMouseLeave
    }, this.contents());
  }

  private contents() {
    const opacityForHoverState = this.state.hovered
      ? HeaderStyles.HoverOpacity
      : HeaderStyles.RestOpacity;

    const style = _.extend({
      backgroundImage: this.props.iconUrl,
      backgroundSize: '19px',
      backgroundPosition: 'left center',
      backgroundRepeat: 'no-repeat',
      cursor: 'pointer',
      opacity: opacityForHoverState,
      padding: '12px 24px 12px 12px'
    }, this.props.style);

    return React.createElement('span', {
      ref: 'headerIconButton',
      style: style,
      'data-tb-test-id': HeaderIconButton.searchBoxIconButtonId,
      onMouseDown: (e: React.MouseEvent<HTMLSpanElement>) => this.ignoreEvent(e),
      onMouseUp: this.boundClick
    });
  }

}

export module HeaderIconButton {

  export interface Props {
    handleClick: () => void;
    iconUrl: string;
    style?: {
      marginLeft?: number;
    };
  }

  export interface State {
    hovered?: boolean;
  }

}
